export const SET_TRANSFER_STOCK_STORE = "SET_TRANSFER_STOCK_STORE";
export const SET_TRANSFER_STOCK_RESET = "SET_TRANSFER_STOCK_RESET";

// Lấy ds chi nhánh
export const FETCH_TRANSFER_STOCK_BRANCH_REQUEST = "FETCH_TRANSFER_STOCK_BRANCH_REQUEST";
export const FETCH_TRANSFER_STOCK_BRANCH_SUCCESS = "FETCH_TRANSFER_STOCK_BRANCH_SUCCESS";
export const FETCH_TRANSFER_STOCK_BRANCH_FAILURE = "FETCH_TRANSFER_STOCK_BRANCH_FAILURE";

// Lấy thông tin chi tiết phí
export const FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST = "FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST";
export const FETCH_TRANSFER_STOCK_MAKE_FEE_SUCCESS = "FETCH_TRANSFER_STOCK_MAKE_FEE_SUCCESS";
export const FETCH_TRANSFER_STOCK_MAKE_FEE_FAILURE = "FETCH_TRANSFER_STOCK_MAKE_FEE_FAILURE";

// Kiểm tra chuyển tiền chứng khoán
export const FETCH_TRANSFER_STOCK_CREATE_REQUEST = "FETCH_TRANSFER_STOCK_CREATE_REQUEST";
export const FETCH_TRANSFER_STOCK_CREATE_SUCCESS = "FETCH_TRANSFER_STOCK_CREATE_SUCCESS";
export const FETCH_TRANSFER_STOCK_CREATE_FAILURE = "FETCH_TRANSFER_STOCK_CREATE_FAILURE";

// Xác nhận chuyển tiền chứng khoán
export const FETCH_TRANSFER_STOCK_CONFIRM_REQUEST = "FETCH_TRANSFER_STOCK_CONFIRM_REQUEST";
export const FETCH_TRANSFER_STOCK_CONFIRM_SUCCESS = "FETCH_TRANSFER_STOCK_CONFIRM_SUCCESS";
export const FETCH_TRANSFER_STOCK_CONFIRM_FAILURE = "FETCH_TRANSFER_STOCK_CONFIRM_FAILURE";

// Xác thực chuyển tiền chứng khoán
export const FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST = "FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST";
export const FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_SUCCESS = "FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_FAILURE = "FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_FAILURE";
